import React, { useState, useEffect, useCallback } from "react";
import MainLayout from "../../Layout/mainLayout";
import { columnsBookingsPayment } from "../../Global Functions/columnsAntd";
import { Table } from "antd";
import "./listBookingPaymentExecutive.css";
import { getPaymentExecutiveList } from "../../Redux/Actions/bookingActions";
import { useDispatch, useSelector } from "react-redux";
import TOTALCARD from "../../Global Icons/BookingProcessed.png";
import COMPLETEDCARD from "../../Global Icons/BookingCompleted.png";
import CANCELLEDCARD from "../../Global Icons/BookingCancelled.png";
import ListTopSearch from "../../Global Functions/listTopSearch";
import { useParams } from "react-router-dom";

const ListBookingsPaymentExec = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchDetails = useCallback(
    (page, limit) => {
      const bookingData = {
        id, // Send id inside payload as API expects
        page,
        limit,
        is_deleted: false,
        filter: searchQuery,
      };
      dispatch(getPaymentExecutiveList(bookingData));
    },
    [dispatch, searchQuery, id]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, searchQuery, id]);

  const { bookingsPaymentExec, loading } = useSelector(
    (state) => state.bookings
  );

  useEffect(() => {
    if (bookingsPaymentExec?.data?.totalCount) {
      setPagination((prevData) => ({
        ...prevData,
        total: bookingsPaymentExec.data.totalCount,
      }));
    }
  }, [bookingsPaymentExec]);


  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const filterHandler = () => {
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchDetails(1, pagination.pageSize);
  };

  return (
    <MainLayout>
      <div className="bookings_table">
        <div className="card_container_list">
          <div className="total_card_list">
            <img src={TOTALCARD} alt="Total Card" />
            <h4>
              Total <br />
              Bookings
            </h4>
            <h1>{bookingsPaymentExec?.data?.total_bookings || "0"}</h1>
          </div>
          <div className="completed_card_list">
            <img src={COMPLETEDCARD} alt="Completed Card" />
            <h4>
              Completed <br />
              Bookings
            </h4>
            <h1>
              {bookingsPaymentExec?.data?.total_confirmed_bookings ?? "0"}
            </h1>
          </div>
          <div className="cancelled_card_list">
            <img src={CANCELLEDCARD} alt="Cancelled Card" />
            <h4>
              Cancelled <br />
              Bookings
            </h4>
            <h1>
              {bookingsPaymentExec?.data?.total_cancelled_bookings ?? "0"}
            </h1>
          </div>
        </div>

        <div className="table_component_all">
          <ListTopSearch
            h3heading="Bookings List"
            filterFunction={filterHandler}
            setState={setSearchQuery}
          />
          <div style={{ padding: "0px 60px" }}>
            <Table
              rowKey={(record) => record._id}
              dataSource={
                bookingsPaymentExec?.data?.data || []
              }
              virtual
              scroll={{ x: 1700, y: 500 }}
              pagination={pagination}
              onChange={handleTableChange}
              loading={loading}
              columns={columnsBookingsPayment}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ListBookingsPaymentExec;
